function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isJSON } from "./utils/common";
import { once } from "./utils/function";
import { isEmpty } from "./utils/lang";

function storageFactory(setItem, getItem, clear) {
  var setStorageItem = function setStorageItem(key, value) {
    return setItem(key, value);
  };

  var getStringWithDefault = function getStringWithDefault(key, defaultItem) {
    try {
      var itemString = getItem(key);
      return isEmpty(itemString) ? defaultItem : itemString;
    } catch (error) {
      return defaultItem;
    }
  };

  var getBooleanWithDefault = function getBooleanWithDefault(key, defaultItem) {
    try {
      var itemString = getItem(key);
      return isEmpty(itemString) ? defaultItem : itemString === "true";
    } catch (error) {
      return defaultItem;
    }
  };

  var getNumberWithDefault = function getNumberWithDefault(key, defaultItem) {
    try {
      var itemString = getItem(key);
      var num = Number(itemString);
      return !isNaN(num) ? num : defaultItem;
    } catch (error) {
      return defaultItem;
    }
  };

  var getJSONWithDefault = function getJSONWithDefault(key, defaultItem) {
    try {
      var itemJSON = getItem(key);

      if (!isJSON(itemJSON)) {
        return defaultItem;
      }

      return JSON.parse(itemJSON);
    } catch (error) {// NOTHING
    }

    return defaultItem;
  };

  var setStorages = {
    setDarkMode: function setDarkMode(darkMode) {
      setStorageItem("storybook-addon-tailwindcss-dark-mode", String(darkMode));
    }
  };
  var getStorages = {
    getDarkMode: function getDarkMode() {
      return getBooleanWithDefault("storybook-addon-tailwindcss-dark-mode", false);
    }
  };
  return _objectSpread(_objectSpread(_objectSpread({}, setStorages), getStorages), {}, {
    clear: clear
  });
}

export var storage = once(function () {
  var setItem = function setItem(key, value) {
    localStorage.setItem(key, value);
  };

  var getItem = function getItem(key) {
    var _localStorage$getItem;

    return (_localStorage$getItem = localStorage.getItem(key)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : "";
  };

  var clear = function clear() {
    return localStorage.clear();
  };

  return storageFactory(setItem, getItem, clear);
});